<template>
  <div class="monitorModel" v-loading="loading">
    <el-tabs tab-position="left" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in monitorList"
        :key="index"
        :label="item.channelName"
        :name="item.channelName">
        <div class="hkiMonDiv">
          <iframe v-if="showHki" :src="item.playerUrl" :id="'hkiMonitorV'+index" class="hkiMonDiv" allowfullscreen></iframe>
        </div>
      </el-tab-pane>
    </el-tabs>
    <template v-if="monitorList.length < 1">
      <el-empty :image="nc" description="暂无监控数据" />
    </template>
  </div>
</template>

<script>
  import { getHkiStreamToken,getDevicesPassagewayList } from "@/api/warehouse";
  const nc = require('@/assets/images/camera.png')
  export default {
    name: "monitorModel",
    props:{
      dataDetail:{
        type:Object
      }
    },
    data(){
      return{
        monitorList:[],
        activeName:"",
        playerDetail: {
          baseUrl: "https://open.ys7.com/ezopen/h5/iframe_se", //基础url
          url: "", //摄像头流url
          autoplay: 1, //自动播放 1-自动，2-主动
          audio: "", //开启音频 1-开启
          accessToken: "", //访问令牌，播放监控地址的必要参数
        },
        playerSrc: "",
        showHki:false,
        loading: false,
        nc
      }
    },
    created() {
      this.getStreamToken();
    },
    mounted() {

    },
    methods:{
      getStreamToken(){
        let self = this;
        self.loading = true;
        getHkiStreamToken({
          depotId: sessionStorage.getItem('depotId')
        }).then(res =>{
          if (res.code == 200){
            self.playerDetail.accessToken = res.data.token;
            // self.initVideo();
            self.monitorList = res.data.deviceList;
            if (self.monitorList.length > 0){
              for (let i=0;i<self.monitorList.length;i++){
                self.initVideo(self.monitorList[i]);
              }
              self.activeName = self.monitorList[0].channelName;
              self.showHki = true;
            }
          }else {
            self.$message.error(res.msg || res.message || "网络请求错误")
          }
        }).catch( err=>{
          console.log("error:", err)
        }).finally(() =>{
          self.loading = false;
        })
      },
      initVideo(val){
        let self = this;
        self.playerDetail.url = "ezopen://open.ys7.com/"+ val.deviceSerial +"/"+ val.channelNo+ ".live";
        val.playerUrl =
          self.playerDetail.baseUrl +
          "?url=" +
          self.playerDetail.url +
          "&autoplay=" +
          self.playerDetail.autoplay +
          "&accessToken=" +
          self.playerDetail.accessToken;
        console.log("最终URL",val.playerUrl);
      },
      handleClick(tab, event) {
        //解决切换时播放器卡屏问题
        this.showHki = false;
        setTimeout( ()=>{
          this.showHki = true;
        },500)
      }
    }
  }
</script>

<style lang="less" scoped>
  .monitorModel{
    .hkiMonDiv{
      width: 100%;
      height: 560px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/warehouse/components/monitorModel.vue